import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUpsertQualificationMutation } from '../../../store/features/qualification/qualificationSlice';
import { BaseQueryError, ValidationErrorData } from '../../../store/types';
import { QualificationWithAddressInputs } from '../types';
import { qualificationInputWithAddressValidationSchema } from '../validation';
import { QualificationInputUpsertForm } from './QualificationInputUpsertForm';

interface QualificationInputUpsertFormContainerProps {
  mode: 'CREATE' | 'EDIT';
  email: string;
  defaultValues?: Partial<QualificationWithAddressInputs>;
  onUpsert?: () => void;
  onFormSubmit?: () => void;
}
export const QualificationInputUpsertFormContainer: React.FC<QualificationInputUpsertFormContainerProps> = ({
  mode,
  email,
  defaultValues,
  onUpsert,
  onFormSubmit,
}) => {
  const [upsertQualification, { isLoading, error, isSuccess }] = useUpsertQualificationMutation();
  const form = useForm<QualificationWithAddressInputs>({
    mode: 'onTouched',
    resolver: yupResolver(qualificationInputWithAddressValidationSchema),
    defaultValues,
  });
  const { setError } = form;

  const onSubmit = async (data: QualificationWithAddressInputs): Promise<void> => {
    await upsertQualification({
      ...data,
      email,
    });
    onFormSubmit && onFormSubmit();
  };

  useEffect(() => {
    if (isSuccess) {
      onUpsert && onUpsert();
    }
  }, [isSuccess, onUpsert]);

  useEffect(() => {
    if (error) {
      const err = error as BaseQueryError;
      if (err.status === 422) {
        const validationErrorData = err.data as ValidationErrorData;
        let keyOfFirstError: string;
        _.forIn(validationErrorData.errors, (error, key) => {
          if (!keyOfFirstError) {
            keyOfFirstError = key;
          }
          setError(
            key as keyof QualificationWithAddressInputs,
            { message: error[0] },
            { shouldFocus: key === keyOfFirstError }
          );
        });
      }
    }
  }, [error, setError]);
  return (
    <QualificationInputUpsertForm
      isSubmitting={isLoading}
      SubmitButtonLabel={mode === 'CREATE' ? 'Create my qualification' : 'Update my qualification'}
      onSubmit={form.handleSubmit(onSubmit)}
      form={form}
      includeAddressField
    />
  );
};
